import React, { useEffect, useState } from 'react';
import Card from '../../components/ui/Card';
import Btn from '../../components/ui/Btn';
import Tabs from '../../components/ui/Tabs';
import { produtosApi } from '../../api/produtos';
import { COLORS } from '../../theme';
import { useTituloPagina } from '../../context/PageTitleContext';
import { useAuth } from '../../context/AuthContext';

import FichaTecnicaTab from './tabs/FichaTecnicaTab';
import FormacaoPrecoTab from './tabs/FormacaoPrecoTab';
import ReposicaoTab from './tabs/ReposicaoTab';
import DadosComerciaisTab from './tabs/DadosComerciaisTab';
import ComposicaoTab from './tabs/ComposicaoTab';
import EstoquesTab from './tabs/EstoquesTab';
import EtapasTab from './tabs/EtapasTab';

const ABAS = [
  { chave: 'ficha', titulo: 'Ficha Técnica' },
  { chave: 'precos', titulo: 'Formação de Preço' },
  { chave: 'reposicao', titulo: 'Reposição' },
  { chave: 'comerciais', titulo: 'Dados Comerciais' },
  { chave: 'composicao', titulo: 'Composição' },
  { chave: 'estoques', titulo: 'Estoques' },
  { chave: 'etapas', titulo: 'Etapas' }
];

const FORM_VAZIO = { tipo_produto: 'revenda', unidade_comercial: 'UN', unidade_tributavel: 'UN', fator_conversao: 1, suspenso: 0 };

// Mesmos padrões da migration (produtos_precos_custos) — usados antes do produto
// existir de verdade no banco, pra já deixar a aba de Formação de Preço preenchível.
const PRECOS_VAZIO = {
  custo_original: 0, outros_custo: 0,
  frete_pct: 0, frete_valor: 0,
  icms_compra_pct: 0, icms_compra_valor: 0,
  dif_icms_pct: 0, dif_icms_valor: 0,
  st_pct: 0, st_custo_valor: 0,
  ipi_compra_pct: 0, ipi_compra_valor: 0,
  icms_venda_pct: 0, csll_pct: 0, pis_pct: 0, cofins_pct: 0,
  diversos_pct: 0, comissao_pct: 0, custo_fixo_pct: 0,
  margem_varejo_pct: 50, margem_geral_pct: 30, margem_promocao_pct: 20, margem_licitacao_pct: 12, margem_minimo_pct: 10,
  estoque_minimo: 0, estoque_maximo: 0, prazo_entrega_dias: null, prazo_validade_dias: null,
  custo_producao: null
};

export default function ProdutoForm({ produtoId, onVoltar, onSalvo }) {
  const { regimeTributario } = useAuth();
  const [abaAtiva, setAbaAtiva] = useState('ficha');
  const [form, setForm] = useState(FORM_VAZIO);
  const [precos, setPrecos] = useState(PRECOS_VAZIO);
  const [idAtual, setIdAtual] = useState(produtoId || null);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');

  useEffect(() => {
    if (!produtoId) return;
    produtosApi.obter(produtoId).then(setForm).catch(() => {});
    produtosApi.obterPrecosCustos(produtoId).then(setPrecos).catch(() => {});
  }, [produtoId]);

  useTituloPagina(idAtual ? `Produto ${form.codigo || ''} - ${form.nome || ''}` : 'Novo Produto');

  const onChange = (campo, valor) => setForm(f => ({ ...f, [campo]: valor }));
  const onChangePrecos = (campo, valor) => setPrecos(p => ({ ...p, [campo]: valor }));

  const salvar = async () => {
    if (!form.nome) { setErro('Nome do Produto é obrigatório'); setAbaAtiva('ficha'); return; }
    setSalvando(true);
    setErro('');
    try {
      let id = idAtual;
      if (id) {
        await produtosApi.atualizar(id, form);
      } else {
        const resultado = await produtosApi.criar(form);
        id = resultado.id;
        setIdAtual(id);
        setForm(f => ({ ...f, codigo: resultado.codigo }));
      }
      const precosAtualizados = await produtosApi.salvarPrecosCustos(id, { ...precos, regime_tributario: regimeTributario });
      setPrecos(precosAtualizados);
      if (onSalvo) onSalvo();
    } catch (e) {
      setErro(e.message);
    } finally {
      setSalvando(false);
    }
  };

  const acaoTabs = (
    <>
      <Btn variante="ghost" onClick={onVoltar}>Voltar</Btn>
      <Btn onClick={salvar} disabled={salvando}>{salvando ? 'Salvando...' : 'Salvar'}</Btn>
    </>
  );

  return (
    <div>
      <Card>
        {erro && <p style={{ color: COLORS.danger, fontSize: 13, marginTop: 0 }}>{erro}</p>}
        <Tabs abas={ABAS} ativa={abaAtiva} onMudar={setAbaAtiva} acao={acaoTabs} />

        {abaAtiva === 'ficha' && <FichaTecnicaTab form={form} onChange={onChange} codigoExibido={form.codigo} />}
        {abaAtiva === 'precos' && <FormacaoPrecoTab dados={precos} onChange={onChangePrecos} regimeTributario={regimeTributario} />}
        {abaAtiva === 'reposicao' && <ReposicaoTab dados={precos} onChange={onChangePrecos} />}
        {abaAtiva === 'comerciais' && <DadosComerciaisTab form={form} onChange={onChange} />}
        {abaAtiva === 'composicao' && <ComposicaoTab produtoId={idAtual} temComposicao={form.tem_composicao} />}
        {abaAtiva === 'estoques' && <EstoquesTab produtoId={idAtual} />}
        {abaAtiva === 'etapas' && <EtapasTab />}
      </Card>
    </div>
  );
}
